import { CONTRACT_ACTION_BASES_URL, CONTRACT_URL } from "../../../constants";
import { getToken } from "../../../context/authContext";
import { ApiServiceManager, fetchRequest } from "../../apiServiceManager";
import {
  IContractActionHistoryRequestBody,
  IContractActionHistoryResponse,
  IContractActionRequestBody,
  IContractActionResponse,
} from "./models";

const defaultProvide = async () => await getToken();

export const doAction = (
  body: IContractActionRequestBody
): Promise<IContractActionResponse> => {
  const descriptor = new ApiServiceManager(
    `${CONTRACT_ACTION_BASES_URL}`,
    "POST",
    defaultProvide
  );
  return fetchRequest(descriptor, body);
};

export const externalDoAction = (
  body: IContractActionRequestBody
): Promise<IContractActionResponse> => {
  const descriptor = new ApiServiceManager(
    `${CONTRACT_ACTION_BASES_URL}external`,
    "POST",
    defaultProvide
  );
  return fetchRequest(descriptor, body);
};

export const getActionsHistory = (
  body: IContractActionHistoryRequestBody
): Promise<IContractActionHistoryResponse> => {
  const descriptor = new ApiServiceManager(
    `${CONTRACT_URL}history?${
      body?.contractId ? `contractId=${body?.contractId || ""}&` : ""
    }${
      body?.actorIds?.length ? `actorIds=${body?.actorIds}&` : ""
    }organizationCode=${body?.organizationCode}&page=${body?.page}&size=${
      body?.size
    }&sort=${body?.sort}`,
    "GET",
    defaultProvide
  );
  return fetchRequest(descriptor);
};
